if (!customElements.get('fa26-image-cards')) {
    class Fa26ImageCards extends HTMLElement {
        connectedCallback() {
            this.init();
        }

        disconnectedCallback() {
            this.teardown();
        }

        init() {
            this.teardown();
            this.toggle = this.querySelector('[data-fa26-toggle]');
            this.toggleButtons = this.toggle ? Array.from(this.toggle.querySelectorAll('[data-fa26-toggle-btn]')) : [];
            if (!this.toggle) return;

            this.handleToggleClick = (event) => {
                const button = event.target.closest('[data-fa26-toggle-btn]');
                if (!button || !this.toggle.contains(button)) return;
                this.setGroup(button.dataset.group);
            };
            this.toggle.addEventListener('click', this.handleToggleClick);
            this.setGroup(this.toggle.dataset.active || this.dataset.defaultGroup || 'hers');
        }

        teardown() {
            if (this.toggle && this.handleToggleClick) {
                this.toggle.removeEventListener('click', this.handleToggleClick);
            }
            this.handleToggleClick = null;
        }

        get activeGroup() {
            return this.toggle ? this.toggle.dataset.active : null;
        }

        setGroup(group) {
            if (!this.toggle || !group) return;
            const changed = this.toggle.dataset.active !== group;
            this.toggle.dataset.active = group;
            this.toggleButtons.forEach((button) => {
                const isActive = button.dataset.group === group;
                button.classList.toggle('is-active', isActive);
                button.setAttribute('aria-pressed', String(isActive));
            });
            this.querySelectorAll('[data-fa26-group]').forEach((card) => {
                card.hidden = card.getAttribute('data-fa26-group') !== group;
            });
            this.refreshCarousel(changed);
        }

        refreshCarousel(resetPosition) {
            const carousel = this.querySelector('fa26-carousel');
            if (!carousel) return;
            if (typeof carousel.refresh === 'function') carousel.refresh();
            if (resetPosition && typeof carousel.scrollToIndex === 'function') carousel.scrollToIndex(0);
        }

        revealCard(card) {
            const group = card.getAttribute('data-fa26-group');
            if (group && this.toggle && group !== this.activeGroup) this.setGroup(group);

            const carousel = this.querySelector('fa26-carousel');
            if (!carousel || typeof carousel.scrollToIndex !== 'function') return;
            const visibleCards = Array.from(this.querySelectorAll('[data-fa26-group]')).filter((item) => !item.hidden);
            const index = visibleCards.indexOf(card);
            if (index >= 0) carousel.scrollToIndex(index);
        }
    }

    customElements.define('fa26-image-cards', Fa26ImageCards);

    document.addEventListener('shopify:section:load', (event) => {
        event.target.querySelectorAll('fa26-image-cards').forEach((element) => element.init());
    });

    document.addEventListener('shopify:block:select', (event) => {
        const card = event.target.closest('[data-fa26-group]');
        const element = card ? card.closest('fa26-image-cards') : null;
        if (element) element.revealCard(card);
    });
}
